import { createTheme, responsiveFontSizes } from "@mui/material/styles";

let theme = createTheme({
  palette: {
    primary: {
      main: "#111111",
      light: "#343434",
      dark: "#050505",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#f05d8f",
      light: "#f6b0c6",
      dark: "#c53c6f",
      contrastText: "#111111",
    },
    info: {
      main: "#d7d1cb",
      light: "#ebe6df",
      dark: "#8e857d",
      contrastText: "#111111",
    },
    warning: {
      main: "#f39a47",
      light: "#f8c794",
      dark: "#c06b1f",
      contrastText: "#111111",
    },
    background: {
      default: "#f4efe8",
      paper: "#fbf8f3",
    },
    text: {
      primary: "#111111",
      secondary: "#5f5a56",
    },
    divider: "rgba(17, 17, 17, 0.12)",
  },
  shape: {
    borderRadius: 4,
  },
  typography: {
    fontFamily: '"Aptos", "Segoe UI", "Helvetica Neue", Arial, sans-serif',
    h1: {
      fontWeight: 800,
      letterSpacing: -2.2,
    },
    h2: {
      fontWeight: 800,
      letterSpacing: -1.4,
    },
    h3: {
      fontWeight: 800,
      letterSpacing: -1,
    },
    h4: {
      fontWeight: 800,
      letterSpacing: -0.8,
    },
    h6: {
      fontWeight: 700,
      letterSpacing: -0.3,
    },
    overline: {
      fontWeight: 700,
      letterSpacing: 2.6,
    },
    button: {
      fontWeight: 700,
      textTransform: "none",
      letterSpacing: 0.2,
    },
    body2: {
      lineHeight: 1.6,
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 4,
          paddingInline: 18,
          minHeight: 42,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          fontWeight: 600,
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: 0,
          backgroundColor: "#fbf8f3",
          overflow: "hidden",
          borderRadius: 4,
        },
        columnHeaders: {
          backgroundColor: "#f1ebe3",
          borderBottom: "1px solid rgba(17, 17, 17, 0.12)",
          textTransform: "uppercase",
          letterSpacing: 0.8,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          borderRadius: 4,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 4,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: "small",
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          backgroundColor: "rgba(255,255,255,0.7)",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRadius: 0,
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
